import { Link } from "react-router-dom";

export interface AuthSwitchLinkProps {
  /** "¿No tienes una cuenta?" */
  prompt: string;
  /** "Crea una" */
  linkLabel: string;
  to: string;
  /**
   * El estado de navegación que se CONSERVA al cambiar de pantalla. Es
   * lo que hace que quien llegó al login desde el carrito y decide
   * registrarse siga volviendo al carrito: sin esto, `state.from` se
   * pierde en el brinco entre las dos pantallas de acceso.
   */
  state?: unknown;
}

/**
 * El pie que manda de una pantalla de acceso a la otra. Es un componente
 * y no dos líneas de JSX porque aparece en login, en registro y aparecerá
 * en recuperar contraseña: tres sitios donde el mismo enlace debe verse
 * exactamente igual.
 */
export function AuthSwitchLink({ prompt, linkLabel, to, state }: AuthSwitchLinkProps) {
  return (
    <>
      {prompt}{" "}
      <Link
        to={to}
        state={state}
        className="font-medium text-ds-violet-pop underline underline-offset-4 transition hover:text-ds-ink-3"
      >
        {linkLabel}
      </Link>
    </>
  );
}
